// GET/POST /providers — la nómina de contratistas de la organización.
//
// Las tablas (`providers`, `provider_contacts`, `provider_categories`)
// existen desde hace tiempo y estaban completas; lo que no existía era
// una ruta que las leyera. Se escribían sólo de dos maneras: inline desde
// el drawer de delegación de facility, y por la hoja «Proveedores» del
// workbook. Ninguna superficie de postventa las tocaba, así que el panel
// no tenía de dónde elegir a quién asignarle una observación.
import { z } from "zod";
import { emailSchema } from "./auth.js";
export const providerListItemSchema = z.object({
    id: z.string().uuid(),
    shortName: z.string(),
    legalName: z.string().nullable(),
    /** Texto libre hoy (la hoja del workbook junta varias categorías con
     *  «;»). El anclaje bueno a futuro es `provider_categories`, que ya
     *  reserva `isPrimary` para «el proveedor por defecto de esta
     *  categoría» — cuando eso se use, la sugerencia del drawer deja de
     *  depender de comparar strings. */
    specialty: z.string().nullable(),
    contactEmail: z.string().nullable(),
    contactPhone: z.string().nullable(),
    /** Observaciones asignadas a este contratista que todavía no están
     *  resueltas ni cerradas. Es la columna «Trabajos activos» de la
     *  nómina, y es calculable desde que la asignación escribe
     *  `findings.provider_id`. */
    activeJobs: z.number().int().nonnegative(),
});
export const providerListResponse = z.object({
    providers: z.array(providerListItemSchema),
});
export const providerCreateBody = z
    .object({
    shortName: z.string().trim().min(1).max(200),
    legalName: z.string().trim().min(1).max(200).optional(),
    specialty: z.string().trim().min(1).max(200).optional(),
    contactEmail: emailSchema.optional(),
    contactPhone: z.string().trim().min(1).max(40).optional(),
})
    .strict()
    // Un contratista sin ninguna forma de contactarlo no sirve para lo
    // único que la nómina existe para hacer: mandarle el enlace.
    .refine((b) => Boolean(b.contactEmail) || Boolean(b.contactPhone), {
    message: "se necesita al menos un correo o un teléfono",
    path: ["contactEmail"],
});
export const providerCreateResponse = z.object({
    provider: providerListItemSchema,
    /** false cuando el nombre ya existía en la organización y la fila se
     *  reusó en vez de duplicarse. El panel ramifica el copy con esto en
     *  vez de afirmar «contratista creado» sobre una fila que ya estaba. */
    created: z.boolean(),
});
//# sourceMappingURL=providers.js.map